import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable, reaction} from 'mobx';
import isNumber from 'lodash/isNumber';
import {ProgressPresentationType, TrackPlayStatus} from '../../../constants/enums';
import {secondsToMilliseconds, secondsToMinutes} from '../../../utils/commonUtility';

type Props = {
    type: number,
    isPlaying: boolean
};

@inject('studioStore')
@observer
class StudioTopBarsTimeBar extends Component<Props> {
    @observable currentTime = 0;
    @observable progress = 0;
    @observable timer = 0;
    @observable lastModified = 0;

    componentDidMount() {
        // this.timeListener = autorun(() => {
        //     this.toggleTimer(this.props.isPlaying, this.props.studioStore.leaderTrack.currentTime);
        // });
        this.modifiedListener = reaction(
            () => this.props.studioStore.leaderTrack.lastModified,
            (lastModified) => {
                this.onTrackChange(lastModified);
                this.toggleTimer(this.props.studioStore.leaderTrack.playStatus === TrackPlayStatus.Playing, this.props.studioStore.leaderTrack.currentTime);
            }, {}
        );
    }

    componentWillUnmount() {
        // this.timeListener();
        this.modifiedListener();
    }

    @action
    onTrackChange(lastModified: number) {
        if (isNumber(lastModified) && lastModified !== this.lastModified) {
            this.currentTime = this.props.studioStore.leaderTrack.currentTime || 0;
            this.progress = this.currentTime / this.props.studioStore.duration;
            this.lastModified = lastModified;
        }
    }

    @action
    toggleTimer(isPlaying: boolean, currentTime: number) {
        clearInterval(this.timer);
        if (isPlaying) {
            this.timer = setInterval(() => {
                this.updateProgress();
            }, 100);
        } else {
            this.handleStopPause(currentTime);
        }
    }

    @action
    handleStopPause(currentTime: number) {
        if (isNumber(currentTime)) {
            this.currentTime = currentTime;
            this.progress = this.currentTime / this.props.studioStore.duration || 0;
        }
    }

    @action
    updateProgress() {
        this.currentTime += 0.1;
        this.progress = this.currentTime / this.props.studioStore.duration;
    }

    render() {
        const {type} = this.props;
        const {beatLength, numBeatsPerBar} = this.props.studioStore;
        const activeBar = Math.floor(this.currentTime / (beatLength * numBeatsPerBar)) + 1 || 1;
        const activeBeat = Math.floor((this.currentTime / beatLength) % numBeatsPerBar) + 1 || 1;
        return (
            <div className="center-top">
                {type === ProgressPresentationType.Bars ?
                    (<div className="tab-value-holder bar" key={ProgressPresentationType.Bars}>
                        <span>{activeBar}</span>
                        <span>.</span>
                        <span>{activeBeat}</span>
                    </div>) :
                    (<div
                        className="tab-value-holder time"
                        key={ProgressPresentationType.Time}>
                        {secondsToMinutes(this.currentTime, 'mm:ss')}.{secondsToMilliseconds(this.currentTime)}
                    </div>)
                }
            </div>
        );
    }
}

export default StudioTopBarsTimeBar;
